import { render } from "./HelpandSupport.vue?vue&type=template&id=3c3d77c2"
import script from "./HelpandSupport.vue?vue&type=script&lang=js"
export * from "./HelpandSupport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__